export default {
  hero: {
    cyclingWords: [
      'comportamiento',
      'lenguaje',
      'accesibilidad',
      'inclusión',
      'percepción',
      'atención',
      'memoria',
      'curiosidad',
      'aprendizaje',
      'conexión',
      'adaptación',
      'claridad',
      'comprensión',
      'pertenencia',
      'confianza',
      'asombro',
      'posibilidades',
      'sentimiento',
    ],
    label: 'Product Design Engineer',
    status: 'Disponible para las cosas correctas',
    headline: {
      line1: 'construyo',
      em: 'cosas',
      line3: 'para humanos.',
    },
    desc: 'Hola, soy <strong>Juan Lias</strong>, un maker multidisciplinario radicado en Curitiba, Brasil. Combino empatía de diseño con precisión de ingeniería para crear experiencias digitales que se sienten humanas desde el primer clic.',
    description: 'Hola, soy un maker multidisciplinario <br /> radicado en Curitiba, PR-Brasil',
    title: {
      first: 'Creando',
      highlight: 'digital',
      last: 'experiencias.',
    },
    scroll: 'Scroll',
    photoAlt: 'Juan Lias — Product Design Engineer',
    ariaSection: 'Hero — Juan Lias portfolio',
  },
  about: {
    watermark: 'Quién soy',
    title: 'Quién soy',
    seeMore: {
      label: 'Descubrir más',
      title: 'Conóceme',
    },
    story:
      "Crecí en el Caribe, en una <span class='story-highlight'>Venezuela</span> que formaba con dureza, días buenos, días duros y una creatividad nacida de la urgencia. Allí aprendí a resolver con poco y a ver orden donde otros veían caos. En 2019 migré a <span class='story-highlight'>Brasil</span> buscando estabilidad y un futuro más claro. Ese salto me obligó a empezar de cero, reinventarme y demostrar que podía subir de nivel incluso en terreno nuevo.",
    heroCard: {
      role: 'Desarrollador Creativo y Diseñador de Interfaces',
      bio: 'Apasionado por crear experiencias digitales conecten con las personas. Combino la lógica del código con la empatía del diseño para construir soluciones útiles, enfocándome en eliminar la fricción para lograr interfaces que se sientan familiares y naturales desde el primer instante.',
      showMore: 'Ver más',
      showLess: 'Ver menos',
    },
    locationCard: {
      label: 'Radicado en',
      country: 'Brasil',
    },
    availabilityCard: {
      status: 'Disponible',
      message: 'para las cosas correctas',
    },
    quoteCard: {
      philosophy: '— Mi filosofía',
      segments: [
        { text: 'No busco la perfe', type: 'type' },
        { text: 'cion', type: 'type', isTypo: true },
        { text: '', type: 'pause', duration: 600 },
        { text: 'cion', type: 'delete' },
        { text: 'cción,', type: 'type' },
        { text: '', type: 'pause', duration: 800 },
        { text: ' solo trato de ser extraordinario.', type: 'type' },
      ],
    },
    experienceCard: {
      label: 'Años de<br />Experiencia',
    },
    neurodivergentCard: {
      teaser: "Mi mente funciona <span class='teaser__highlight'>diferente</span>.",
      teaserSub: 'Autismo N1 · Altas Capacidades',
      button: 'Ver perfil cognitivo',
      label: 'Neurodivergente',
      sublabel: 'Perfil Cognitivo',
      hide: 'Cerrar',
      traits: [
        { id: 'hyperfocus', name: 'Hiperfoco' },
        { id: 'patterns', name: 'Rec. de Patrones' },
        { id: 'precision', name: 'Precisión' },
        { id: 'systems', name: 'Pensamiento Sistémico' },
        { id: 'lateral', name: 'Pensamiento Lateral' },
        { id: 'curiosity', name: 'Curiosidad Profunda' },
      ],
      footer:
        "Diferente por diseño. <span class='footer-highlight'>Resultados extraordinarios.</span>",
    },
    hobbiesCard: {
      title: 'Más allá del sistema',
      text: 'Fe, ciencia y el impulso de superación. Un balance entre el diseño de Dios, las leyes de la física y la disciplina de romper mis propios límites.',
      hobbies: [
        'Dios',
        'Familia',
        'Ciencia',
        'Física',
        'Astrofísica',
        'Diseño',
        'Artes',
        'Música',
        'Gaming',
        'Dragon Ball',
      ],
    },
    readingCard: {
      title: 'Leyendo actualmente',
    },
    familyCard: {
      title: "La familia primero <span class='family-card__hearts'>❤️</span>",
      text: 'Mi familia es mi fuerza cuando flaqueo, mi alegría cuando estoy agotada y la razón por la que nunca me detengo. Son mi prioridad, mi tierra firme y mi bendición diaria. Agradezco a Dios por guiarnos y sostenernos en cada paso.',
    },
    momentsCard: {
      title: 'Momentos detrás de los píxeles',
      labels: {
        alwaysLearning: 'Siempre aprendiendo 📚',
        dreamTeam: 'Dream Team 💜',
      },
    },
    setupCard: {
      items: {
        dell: { detail: 'Core i7 13th Gen • GEFORCE RTX • 32GB RAM • 1TB SSD' },
        mic: { detail: 'Micrófono Condensador USB' },
        webcam: { detail: 'Webcam 2k' },
        mouse: { detail: 'Ratón' },
        mousepad: { detail: 'Mousepad' },
        tablet: { detail: 'Tableta Gráfica' },
        buds1: { detail: 'Auriculares Inalámbricos' },
        buds2: { detail: 'Auriculares Inalámbricos' },
        headphones: { detail: 'Auriculares Diadema' },
        keyboard: { detail: 'Teclado' },
        bible: { detail: 'Guía Espiritual' },
        book: { detail: 'Libro UX de Don Norman' },
        speaker: { detail: 'Altavoz Inteligente' },
        monitor1: { detail: 'Full HD • IPS' },
        timer: { detail: 'Temporizador Pomodoro' },
        monitor2: { detail: 'Full HD • IPS' },
        controller: { detail: 'Para descansos de juego 🎮' },
      },
    },
    languagesCard: {
      title: 'Idiomas',
      items: [
        { name: 'Español', level: 'Nativo' },
        { name: 'Portugués', level: 'Fluido' },
        { name: 'Inglés', level: 'B2 y Aprendiendo' },
      ],
    },
  },
  whatIDo: {
    title: {
      first: 'Lo que',
      highlight: 'Hago',
    },
    services: {
      uiUx: {
        title: 'UI/UX',
        description:
          'Diseñando interfaces intuitivas centradas en el usuario que combinan estética con una funcionalidad perfecta',
      },
      frontend: {
        title: 'ENGINEER',
        description:
          'Desarrollando aplicaciones web escalables y de alto rendimiento utilizando arquitectura moderna',
      },
      creative: {
        title: 'CREATIVO',
        description: 'Diseñando y programando interfaces digitales con un toque humano.',
      },
      interaction: {
        title: 'INTERACTION',
        description: 'Cada clic, hover y scroll — obsesivamente considerado.',
      },
      humanity: {
        title: 'HUMANITY',
        description: 'Propósito humano, ejecución técnica.',
      },
    },
  },
  worksComingSoon: {
    badge: 'En Construcción',
    title: 'Analizando Ideas<br />Hacia la Realidad',
    description:
      'Actualmente estoy seleccionando mis mejores proyectos para mostrarlos aquí. Espera algo especial pronto.',
    loading: {
      initializing: 'Inicializando...',
      states: [
        'Mejorando Casos de Usuario...',
        'Diseñando flujos de usuario...',
        'Optimizando assets gráficos...',
        'Refinando interacciones...',
        'Preparando documentación...',
        'Compilando mejores proyectos...',
      ],
    },
  },
  journeyV2: {
    label: 'Cronología Profesional',
    title: 'Experiencia',
    connect: 'Conectar en LinkedIn',
    items: [
      {
        id: 1,
        company: 'Compliance Soluções',
        role: 'Consultor Especialista Senior en Desarrollo UX',
        location: 'Remoto - Ribeirão Preto, São Paulo, Brasil',
        period: 'May 2022 - Actualidad',
        description:
          'Liderando la migración UX de una plataforma fiscal heredada que sirve a más de 100 empresas. Optimizando flujos de trabajo para más de 20k facturas mensuales a través de investigación, prototipado y estrecha colaboración con Product Owners.',
        startYear: 2022,
        endYear: 2025,
      },
      {
        id: 2,
        company: 'Simplify Tanzania',
        role: 'Director de Arte',
        location: 'Remoto - Dar es Salaam, Tanzania',
        period: 'Jun 2019 - Dic 2022',
        description:
          'Dirigí la dirección creativa desde la definición del MVP hasta la implementación frontend. Diseñé interfaces de alta fidelidad para la gestión de facturas y establecí la identidad visual de la marca en canales digitales y sociales.',
        startYear: 2019,
        endYear: 2022,
        roles: [
          {
            title: 'Director de Arte',
            period: 'Feb 2021 - Oct 2022',
            type: 'Tiempo completo',
          },
          {
            title: 'Diseñador de Producto UI/UX Senior y Desarrollador Front-end',
            period: 'Oct 2020 - Feb 2021',
            type: 'Contrato',
          },
        ],
      },
      {
        id: 3,
        company: 'Katavi Gaming Limited',
        role: 'Consultor Senior de Diseño de Producto UI/UX',
        location: 'Dar es Salaam, Tanzania',
        period: 'Oct 2017 - May 2022',
        description:
          'Dirigí el departamento de UI/UX para plataformas de apuestas, optimizando para accesibilidad en dispositivos. Gestioné el ciclo completo de diseño desde la investigación hasta el lanzamiento usando SCRUM, mientras definía la identidad corporativa y activos de marketing.',
        startYear: 2017,
        endYear: 2022,
        roles: [
          {
            title: 'Consultor Senior de Diseño de Producto UI/UX',
            period: 'Dic 2020 - May 2022',
            type: 'Freelance',
          },
          {
            title: 'Diseñador de Producto UI/UX y Desarrollador Front-end',
            period: 'Abr 2018 - Dic 2020',
            type: 'Tiempo completo',
          },
          {
            title: 'Desarrollador Front-end Junior y Diseñador UI/UX',
            period: 'Oct 2017 - Abr 2018',
            type: 'Tiempo completo',
          },
        ],
      },
      {
        id: 4,
        company: 'Freelancer',
        role: 'Diseñador de Producto y Desarrollador',
        location: 'Global',
        period: 'Ene 2016 -',
        description:
          'Brindando soluciones versátiles de diseño y desarrollo para clientes globales. Los proyectos van desde la creación de identidades corporativas y empaques para marcas educativas hasta el diseño de interfaces para plataformas de juegos emergentes.',
        startYear: 2016,
        endYear: 2025,
      },
    ],
  },
  testimonials: {
    title: 'Impacto Colaborativo',
    subtitle:
      'He tenido el placer de colaborar con personas increíbles. Aquí está lo que tienen que decir.',
    items: [
      {
        id: 1,
        initials: 'J. A.',
        name: 'Jesus A. A. Rojas',
        role: 'Jefe de Almacén en Traslogistic de Venezuela',
        company: 'TBET',
        quote:
          'Juan tiene un increíble poder creativo, aprende rápido y es autodidacta. Tiene la capacidad de captar la visión del proyecto y utilizar sus habilidades para mejorarlo o agregar valor.',
        linkedin: 'https://www.linkedin.com/in/jesus-armando-acosta-rojas/',
      },
      {
        id: 2,
        initials: 'B. C.',
        name: 'Baraka S. Cassian',
        role: 'Fundador y Director General, Simplitech Ltd (Simplify)',
        company: 'SIMPLIFY',
        longQuote: true,
        quote:
          'Trabajar con Juan en el producto y la experiencia frontend de Simplify ha sido un placer. Entendió rápidamente nuestro producto, nuestros usuarios y las limitaciones en las que operamos, y luego tradujo ideas sueltas en interfaces limpias e intuitivas. Aprecié cómo se comunicaba claramente, iteraba rápido en los comentarios y prestaba atención a los pequeños detalles que hacen que un producto se sienta pulido. Juan aporta una rara mezcla de artesanía de diseño, confiabilidad y cuidado genuino por el resultado del proyecto. ¡Es en general una persona amable y genial para trabajar!',
        linkedin: 'https://www.linkedin.com/in/bcassian/',
      },
      {
        id: 3,
        initials: 'C. Z.',
        name: 'Carlos Zerpa',
        role: 'Senior Software Engineer',
        company: 'SIMPLIFY',
        quote:
          'Trabajar junto a Juan Lias en el proyecto Simplify VFD fue un testimonio de su talento excepcional. Su liderazgo en diseño de productos, junto con su experiencia en Vue.js, resultó en una aplicación pulida e intuitiva. Su profesionalismo, atención al detalle y espíritu colaborativo lo convierten en un diseñador y desarrollador destacado.',
        linkedin: 'https://www.linkedin.com/in/carlos-javier-zerpa/',
      },
      {
        id: 4,
        initials: 'M. V.',
        name: 'Mariana Vielma',
        role: 'Product Owner',
        company: 'SIMPLIFY',
        longQuote: true,
        quote:
          'Juan es un profesional extraordinario con un talento increíble y un gran sentido del humor, lo que hace que la colaboración sea productiva y agradable. Sus diseños siempre llevan su firma "chispa extra", ese toque único que eleva cada proyecto y te deja con ganas de ver más de su trabajo. Consistentemente da el 100% en todo lo que hace, aportando creatividad, atención al detalle y una fuerte visión que agregan valor real a cualquier producto o equipo.',
        linkedin: 'https://www.linkedin.com/in/mariana-vielma-67585a237/',
      },
      {
        id: 5,
        initials: 'C. S.',
        name: 'Cezar Sakugawa',
        role: 'Product Manager',
        company: 'Compliance Soluções Fiscais',
        quote:
          'Tuve el privilegio de liderar a Juan y puedo decir que se destaca donde pocos logran equilibrar: visión estratégica de producto con ejecución refinada en diseño. Su atención al detalle va más allá de la estética — piensa en la experiencia del usuario de principio a fin. Su comunicación clara y actitud colaborativa lo convierten en alguien que eleva el nivel de cualquier equipo que tenga la suerte de tenerlo.',
        linkedin: 'https://www.linkedin.com/in/cezarsakugawa/',
      },
      {
        id: 6,
        initials: 'V. S.',
        name: 'Vinícius Santos',
        role: 'Product Owner',
        company: 'Compliance Soluções Fiscais',
        quote:
          'En la empresa donde trabajé con Juan, mantuvimos contacto en todo momento de principio a fin, haciendo que la colaboración fuera siempre activa y efectiva. Admito que, como Product Owner, es complejo prestar atención a todas las partes interesadas, pero Juan nunca se escondió y siempre mostró iniciativa al buscarme, ya sea para resolver una duda o incluso para presentarme un prototipo de alta fidelidad de una nueva funcionalidad. Nunca tuvo miedo de mostrar sus ideas y trabajar duro en ellas para hacerlas realidad, siempre buscando escuchar feedback para mejorar cada vez más y entregar valor al usuario. Las ganas de hacer que las cosas sucedan es, sin duda, su punto más fuerte.',
        linkedin: 'https://www.linkedin.com/in/vinícius-santos',
      },
    ],
  },
  works: {
    section: {
      built: 'Lo que he construido',
      building: 'Lo que estoy construyendo',
      otherLine1: '& otras cosas',
      otherLine2: 'que construí y ayudé a construir',
      closing: 'Sigo aprendiendo. Sigo construyendo.',
    },
    ui: {
      caseStudy: 'Caso de Estudio',
      comingSoon: 'Próximamente',
      visitProject: 'Visitar Proyecto',
    },
    projects: {
      'ultra-instinct': {
        category: 'Extensión de VS Code',
        description:
          'Una trilogía de temas para VS Code diseñada para neurodivergentes, creada para eliminar el ruido visual y lograr un estado de concentración y flujo profundo.',
      },
      braillihub: {
        category: 'Herramienta de Accesibilidad',
        description:
          'Un espacio para explorar los idiomas que conectan a las personas, más allá de las palabras. Traduce texto a Braille, Código Morse o Cifrado César — y explóralos con herramientas interactivas diseñadas para la curiosidad.',
      },
      milo: {
        category: 'Personaje de Marca',
        description:
          'Milo es el personaje de marca de Braillihub — un pequeño explorador curioso que cree que todo idioma merece ser comprendido. Está aquí para encarnar el espíritu del descubrimiento y acompañarte mientras exploras Braille, Morse y más.',
      },
      firmamesh: {
        category: 'Gradientes atmosféricos',
        description:
          'Reúne 141 paisajes atmosféricos reales de 75 países, con 5 momentos del día usando OKLCH para transiciones de color vivas. El slider recorre el arco solar completo — desde el nadir hasta el cenit — con sol, luna y estrellas en tiempo real, fase lunar astronómica. Permite copiar el gradiente como CSS, exportar SVG para Figma o descargar imagen en alta resolución. Incluye editor de capas atmosféricas con control fino de luminosidad, croma y matiz.',
      },
      hyperdrive: {
        category: 'Portafolio Web',
        description:
          'Un impresionante sitio de portafolio con una animación de viaje interestelar construido con Vue 3 y con suaves transiciones GSAP.',
      },
    },
    inProgress: {
      hogarflow: {
        category: 'Centro de Comando del Hogar',
        description:
          'HogarFlow es una plataforma inteligente del hogar que centraliza finanzas, compras, tareas y rutinas en un solo lugar — diseñada para que los usuarios dejen de gestionar y empiecen a vivir, con Shury como el asistente de IA que se encarga de todo.',
      },
      shury: {
        category: 'Asistente IA de HogarFlow',
        description:
          'Shury es la asistente de IA de HogarFlow — gestiona finanzas, tareas, notas, suscripciones y se encarga de los encargos del hogar en nombre del usuario, para que puedan vivir con calma y control.',
      },
    },
    otherProjects: {
      tbet: {
        description:
          'Lideré el departamento de UI/UX en Katavi Gaming Limited (Tanzania) — investigación de usuarios, sistema de diseño, wireframes e interfaces accesibles para dispositivos más antiguos. También fui responsable de la implementación frontend. Seguí el ciclo completo de desarrollo del producto bajo SCRUM/Jira, y colaboré con marketing en la identidad corporativa y contenidos para redes sociales.',
      },
      cassian: {
        description:
          'Rebranding completo y renovación del sitio web de una firma de contabilidad pública certificada y consultoría fiscal en Tanzania (Dar es Salaam y Arusha) — renovación de la identidad visual, rediseño completo del sitio, desde el concepto hasta el despliegue.',
      },
      'simplify-vfd': {
        description:
          'En Simplitech Limited (Tanzania), lideré el diseño del producto de principio a fin — investigación de competidores, identidad de marca, definición del MVP e interfaces de alta fidelidad. También fui responsable de todo el frontend y las integraciones con APIs, y codiseñé el sistema visual de marketing.',
      },
    },
  },
}
